import React, { PropTypes, PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { removeRequest } from '../../../../store/requests/actions';
import { Container } from '../../../shared';
import { PendingList } from './PendingList/main';

import './styles.scss';

export class PendingComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { clockins: [], clockouts: [] };
  }

  componentWillMount() {
    if (this.props.employees) {
      const { employees } = this.props;
      const pending = this.props.requests.reduce((pend, { id, data }) => {
        const employee = employees.find(emp => emp.id === data.user_id);
        if (employee) {
          const { name, clockedIn } = employee;
          const { time } = data;
          pend[`${data.type}s`].push({ name, status: clockedIn, time });
        } else {
          this.props.removeRequest(id);
        }
        return pend;
      }, { clockins: [], clockouts: [] });

      this.setState(pending);
    }
  }

  componentDidMount() {
    this.props.setAndStartTimer(30000);
  }

  render() {
    return (
      // TODO: FIX THIS ANIMATION
      <div className='pending' key='pendingKey'>

        <Container>
          <ReactCSSTransitionGroup
            component='div'
            className='pendingBlock'
            transitionName='pendingSlide'
            transitionAppear
            transitionEnter={false}
            transitionLeave={false}
            transitionAppearTimeout={400}
          >
            {
              /**
              * Contains the pending clockins
              * */
            }

            <div className="option-title">
              <h3><i className="fa fa-clock-o" />Pending clock ins</h3>
              <p>
                These clock ins are saved to the time clock,
                and will be sent to Tanda as soon as possible.
              </p>
            </div>

            <PendingList
              title="Clock Ins"
              amount={this.state.clockins.length}
              list={this.state.clockins}
            />
            <PendingList
              title="Clock Outs"
              amount={this.state.clockouts.length}
              list={this.state.clockouts}
            />
          </ReactCSSTransitionGroup>
        </Container>
      </div>
    );
  }
}

PendingComponent.propTypes = {
  removeRequest: PropTypes.func,
  setAndStartTimer: PropTypes.func,
  requests: PropTypes.array,
  employees: PropTypes.array,
};

/**
 * Maps the components props to the relevant part of application state.
 * @param  {Map} state: the applications state
 * @return {Object} the components props mapped to their locations's state.
 */
function mapToState(state) {
  return {
    employees: state.get('employees').toJS(),
    requests: state.get('requests').toJS(),
  };
}

/**
 * The connected component
 * @param  {Function} mapToState: the function returning the properties mapped
 * to their locations
 * @param  {Function} actions: the function with all properties mapped to
 * the componented actions.
 * @return {Class} the connected component
 */
export const Pending = connect(mapToState, { removeRequest })(PendingComponent);



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/pending/main.jsx